/**
 * Holds the RUM instance so we can flush immediately in dev (e.g. after recordZ4RumError).
 * Set from index.tsx after initZ4Rum(); then components can call flushZ4Rum() to force
 * a dispatch so the request shows in the network tab.
 */

type AwsRum = { dispatch?: () => void };

let rumInstance: AwsRum | null = null;

export function setZ4RumInstance(rum: AwsRum | null): void {
  rumInstance = rum;
}

export function flushZ4Rum(): void {
  if (typeof rumInstance?.dispatch === 'function') {
    rumInstance.dispatch();
  }
}
